import * as React from 'react';
import clsx from 'clsx';
import Icons from '@/const/icons';
import { Button, Icon } from '@/components/common';
import { PinButtonProps } from '@/interfaces';

export const PinButton: React.FC<PinButtonProps> = ({
	isPinned,
	onClick,
	noneClick,
}) => {
	const pinIcon = isPinned ? Icons.pinFulled : Icons.pin;
	return (
		<Button
			onClick={onClick}
			className={clsx('rounded-lg !p-2', {
				'bg-gray-10': !isPinned,
				'bg-purple-35 border-transparent': isPinned,
				'cursor-default': noneClick,
			})}
		>
			<Icon
				src={pinIcon}
				className={clsx('!w-4 !h-4', {
					'text-primary': isPinned,
				})}
			/>
		</Button>
	);
};
